<app-back-header-atom
  icon="arrow-left"
  [text]="'group-payments.title' | translate"
  (navigationClick)="back()"
></app-back-header-atom>
